import * as React from 'react';
import { useState, useEffect } from 'react';

/** Material UI Packages. */
import { Paper, Typography, Tooltip, IconButton } from '@mui/material';
import Grid from '@mui/material/Grid2';

/** Material UI Icons. */
import ListAltIcon from '@mui/icons-material/ListAlt';
import RefreshIcon from '@mui/icons-material/Refresh';

/** Auth0 authenticator Packages. */
import { useAuth0 } from '@auth0/auth0-react';

/** Redux Packages. */
import { useDispatch, useSelector } from 'react-redux';

/** Redux Reducers. */
import { setTaskboard } from 'shared/store/slices/taskboardSlice';

/** Internal Components. */
import { customized_style } from 'shared/config/Styles';
import { CustomSkeleton2 } from 'shared/ui/Skeleton';
import { PageHeader } from 'shared/ui/HeaderIcon';
import { readSocketData } from 'shared/lib/fetchSocket';

import MemberColumn from './components/MemberColumn';
import { todoSections, categories } from 'data/dashboardConfig';

export default function Taskboard() {
    /** Auth0 authenticator. */
    const { user } = useAuth0();

    /** Get the dispatch function from Redux to send actions to the store. */
    const dispatch = useDispatch();

    /** State for showing the connection status of the WebSocket. */
    const socketConnected = useSelector((state) => state.socketStatus.socketStatus);
    /** State for the taskboard information. */
    const taskboardData = useSelector((state) => state.taskboard);

    /** State for the loading status. */
    const [loaded, setLoaded] = useState(false);
    /** State for the alone status. */
    const [hasMember, setHasMember] = useState(true);
    /** State for the refresh trigger. */
    const [refreshTrigger, setRefreshTrigger] = useState(false);

    /** Named website title. */
    useEffect(() => {
        document.title = 'Task Board | Operation System';
    }, []);

    /** useEffect to load the taskboard information when the socket connection is established. */
    useEffect(() => {
        if (socketConnected) {
            setLoaded(false);
            readSocketData(dispatch, '', 'row', 'il_task_board', null, user.email, (receivedData) => {
                if (receivedData.length === 0) setHasMember(false);
                dispatch(setTaskboard(receivedData));
                setLoaded(true);
            });
        }
    }, [socketConnected, refreshTrigger]);

    return (
        <Paper sx={{ ...customized_style.itemPaper_overflow, pb: 0 }}>
            {loaded ? (
                <>
                    {
                        <PageHeader
                            title={'TASK BOARD'}
                            icon={ListAltIcon}
                            children={
                                <IconButton onClick={() => setRefreshTrigger((prev) => !prev)}>
                                    <Tooltip title="Refresh">
                                        <RefreshIcon
                                            sx={{
                                                fontSize: 18,
                                                color: 'white',
                                                bgcolor: 'primary.dark',
                                                borderRadius: '15px',
                                            }}
                                        />
                                    </Tooltip>
                                </IconButton>
                            }
                        />
                    }
                    <Grid container spacing={1}>
                        {!hasMember ? (
                            <Grid item={12} sx={{ display: 'flex', alignItems: 'center', px: 0.2, mb: 1 }}>
                                <Typography sx={{ fontSize: 16, fontWeight: 'bold' }}>
                                    No team members assigned😅
                                </Typography>
                            </Grid>
                        ) : (
                            taskboardData.map((member, idx) => (
                                <MemberColumn
                                    key={idx}
                                    member={member.name}
                                    categories={categories}
                                    todoSections={todoSections(member.todoRows)}
                                />
                            ))
                        )}
                    </Grid>
                </>
            ) : (
                <CustomSkeleton2 />
            )}
        </Paper>
    );
}
